import React from 'react';
// import { Button } from 'antd';
import DiagramUtils from '../../utils/DiagramUtils';
import DiagramsContainer from '../../containers/DiagramsContainer';
import DiagramUI from "../DiagramUI";
import Model from "./GroupModel";

export default class UI extends DiagramUI {

    state = {};

    constructor(props, context) {
        super(props, context);
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        if ((name === "layoutOrientation" ||
            name === "flexWrap" ||
            name === "alignItems" ||
            name === "justifyContent"
        ) && this.containerRef)
            this.containerRef.forceUpdate();
    }

    onClick(e) {
        this.activeEvent("onClick", e);
    }

    onMouseDown(e) {
        this.activeEvent("onMouseDown", e);
    }

    onMouseUp(e) {
        this.activeEvent("onMouseUp", e);
    }

    render() {

        return (
            <div className={"diagram-ui " + (this.props.className || "")} style={this.props.model.toStyle()}
                onClick={e => this.onClick(e)}
                onMouseDown={e => this.onMouseDown(e)}
                onMouseUp={e => this.onMouseUp(e)}>
                <DiagramsContainer ref={ref => this.containerRef = ref}
                    diagrams={this.props.model.diagrams}
                    designer={this.props.model._sys.designer}
                    parent={this.props.model}
                    flag={this.props.model.flag} />
            </div>
        );
    }
}

const type = new Model().getType();
DiagramUtils.register(type, {
    model: Model,
    name: type,
    enabled: true,
    alias: "容器",
    catalog: "布局与模板",
    catalogIndex: -100,
    svg: "#anticon-MasterLayout",
    uiGetter: (model) => <UI model={model} />
});



let template = {
    width: 250,
    height: 500,
    layoutOrientation: "v",
    diagrams: [
        {
            type: "GroupModel",
            model: {
                name: "上",
                layoutMode: "flex",
                flex: -1,
                width: -1,
                height: 50
            }
        },
        {
            type: "GroupModel",
            model: {
                name: "内容",
                layoutMode: "flex",
                flex: 1,
                width: -1,
                height: 1
            }
        },
        {
            type: "GroupModel",
            model: {
                name: "下",
                layoutMode: "flex",
                flex: -1,
                width: -1,
                height: 50
            }
        },
    ]
};

DiagramUtils.register(type + "-垂直布局", {
    model: JSON.stringify(new Model(template).toJsonObject()),
    name: type + "-垂直布局",
    alias: "垂直布局",
    catalog: "布局与模板",
    svg: "#anticon-layout-join_vertical",
    uiGetter: (model) => <UI model={model} />
});

template = {
    width: 500,
    height: 250,
    layoutOrientation: "h",
    diagrams: [
        {
            type: "GroupModel",
            model: {
                name: "左",
                layoutMode: "flex",
                flex: -1,
                width: 50,
                height: -1
            }
        },
        {
            type: "GroupModel",
            model: {
                name: "内容",
                layoutMode: "flex",
                flex: 1,
                width: 1,
                height: -1
            }
        },
        {
            type: "GroupModel",
            model: {
                name: "右",
                layoutMode: "flex",
                flex: -1,
                width: 50,
                height: -1
            }
        },
    ]
};

DiagramUtils.register(type + "-水平布局", {
    model: JSON.stringify(new Model(template).toJsonObject()),
    name: type + "-水平布局",
    alias: "水平布局",
    catalog: "布局与模板",
    svg: "#anticon-layout-join",
    uiGetter: (model) => <UI model={model} />
});